module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Undo-e56f35ca10af8ff7fe6798eee7de6beb7e58fa3f59baae846f8fe01b78973051.svg";